// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"249":"581ba974","791":"283f4713"}[chunkId] + ".js";
};